import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export interface NavigationItem {
  label: string;
  paths: string[];
}

export function useActiveNavigation(navigationItems: NavigationItem[]) {
  const location = useLocation();

  useEffect(() => {
    function updateActiveNavigation() {
      const buttons = document.querySelectorAll(
        'header .MuiButtonBase-root.MuiButton-root, header .MuiButtonBase-root, header a'
      );
      const currentPath = location.pathname;

      if (!buttons.length) return;

      buttons.forEach((button) => {
        const buttonElement = button as HTMLElement;
        const navLabel = buttonElement.textContent?.trim() ?? '';

        buttonElement.classList.remove('active');
        if (!navLabel) return;

        const navItem = navigationItems.find((item) => item.label === navLabel);
        if (!navItem) return;

        const isActive = navItem.paths.some((path) => {
          if (path === '/') return currentPath === '/';
          if (path.endsWith('/')) return currentPath.startsWith(path);
          return currentPath === path;
        });

        if (isActive) buttonElement.classList.add('active');
      });
    }

    updateActiveNavigation();
    const timeoutId = setTimeout(updateActiveNavigation, 250);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [location.pathname, navigationItems]);
}
